module.exports = __webpack_public_path__ + "img/IMG_7106.d8dc636c.webp";